import { render, staticRenderFns } from "./DocumentDetail.vue?vue&type=template&id=2a2e7804&scoped=true"
import script from "./DocumentDetail.vue?vue&type=script&lang=js"
export * from "./DocumentDetail.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetail.vue?vue&type=style&index=0&id=2a2e7804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e7804",
  null
  
)

export default component.exports